export default (str) => {
  let tempString = str.replace(/-/g, " ");
  tempString = tempString.replace(/\$/g, "/");

  return tempString.replace(/~/g, "-");
};
